module.exports = __webpack_public_path__ + "fonts/medium.ef0d359b.woff2";